import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["key"],
  _excluded2 = ["key"],
  _excluded3 = ["key"],
  _excluded4 = ["key"];
import React from "react";
import Button from "../../../Button";
import { EMPTY_OBJ } from "../../../helpers/logic/empties";
import VARIANT_OPTIONS from "../../constants";
import { BaseDialogActions } from "./styled";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function DialogActions(_ref) {
  var primaryButtonProps = _ref.primaryButtonProps,
    secondaryButtonProps = _ref.secondaryButtonProps,
    tertiaryButtonProps = _ref.tertiaryButtonProps,
    cancelButtonProps = _ref.cancelButtonProps,
    variant = _ref.variant;
  // `key` must reach JSX directly: spread, React 18.3 warns and React 19 drops it.
  var _ref2 = primaryButtonProps || EMPTY_OBJ,
    primaryKey = _ref2.key,
    primaryRest = _objectWithoutProperties(_ref2, _excluded);
  var _ref3 = secondaryButtonProps || EMPTY_OBJ,
    secondaryKey = _ref3.key,
    secondaryRest = _objectWithoutProperties(_ref3, _excluded2);
  var _ref4 = tertiaryButtonProps || EMPTY_OBJ,
    tertiaryKey = _ref4.key,
    tertiaryRest = _objectWithoutProperties(_ref4, _excluded3);
  var _ref5 = cancelButtonProps || EMPTY_OBJ,
    cancelKey = _ref5.key,
    cancelRest = _objectWithoutProperties(_ref5, _excluded4);
  var primaryLabel = primaryRest.label;
  var secondaryLabel = secondaryRest.label;
  var tertiaryLabel = tertiaryRest.label;
  var cancelLabel = cancelRest.label;
  return /*#__PURE__*/_jsxs(BaseDialogActions, {
    children: [VARIANT_OPTIONS[variant].cancelActionAllowed && cancelButtonProps && /*#__PURE__*/_jsx(Button, _extends({
      appearance: "ghost"
    }, cancelRest, {
      children: cancelLabel
    }), cancelKey), VARIANT_OPTIONS[variant].secondaryActionsAllowed && /*#__PURE__*/_jsxs(_Fragment, {
      children: [tertiaryButtonProps && /*#__PURE__*/_jsx(Button, _extends({}, tertiaryRest, {
        children: tertiaryLabel
      }), tertiaryKey), secondaryButtonProps && /*#__PURE__*/_jsx(Button, _extends({}, secondaryRest, {
        children: secondaryLabel
      }), secondaryKey)]
    }), primaryButtonProps && /*#__PURE__*/_jsx(Button, _extends({
      appearance: VARIANT_OPTIONS[variant].primaryActionVariant
    }, primaryRest, {
      children: primaryLabel || VARIANT_OPTIONS[variant].primaryActionText
    }), primaryKey)]
  });
}
export default DialogActions;